﻿<!-- 定义全局变量 -->
<script type="text/javascript">
// ******默认url链接********
// var urlBase="http://192.168.1.103:8082/"; //168
//	var urlBase="http://192.168.1.192:8080/api";   //陈勇
//var urlBase="http://110.cs.gc80.cn";   //陈勇
   var urlBase="https://m-zzjy.ahharc.com/api";               //正式
// var urlBase="http://weixin.ahsjxjy.com/api";          //微信测试

// ******图片链接********
var imgBase="https://zzjy.ahharc.com";

export default
{
  urlBase,
  imgBase
}
</script>



// WEBPACK FOOTER //
// global.vue?12767043